export const PUBLIC_CONTAINER = "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8";

export const PUBLIC_SECTION_PY_MARKETING = "py-14 sm:py-20 lg:py-24";

export const PUBLIC_SECTION_PY_CONTENT = "py-12 sm:py-16";

export const PUBLIC_PANEL_RADIUS = "rounded-2xl";

export const PUBLIC_GRID_GAP = "gap-6";